import { Injectable } from '@angular/core';
import { Model } from 'survey-core';
import { CivicDataUtilsService } from './civic-data.utils.service';

@Injectable({
  providedIn: 'root'
})
export class MappedFieldsService {
  isLoading = false;

  constructor(private civicDataUtilsService: CivicDataUtilsService) {
  }

  processMappedData(surveyModel: any, source: any, objectToProcess: any) {
    const mappedFields = this.getMappedFields(surveyModel);
    switch (source) {
      case 'person':
        if (objectToProcess) {
          if (mappedFields.FirstName.question !== '') {
            surveyModel.setValue(mappedFields.FirstName.question, objectToProcess.first_name);
            surveyModel.getQuestionByName(mappedFields.FirstName.question).readOnly = true;
          }
          if (mappedFields.LastName.question !== '') {
            surveyModel.setValue(mappedFields.LastName.question, objectToProcess.last_name);
            surveyModel.getQuestionByName(mappedFields.LastName.question).readOnly = true;
          }
          if (mappedFields.FullName.question !== '') {
            surveyModel.setValue(mappedFields.FullName.question, objectToProcess.first_name + ' ' + objectToProcess.last_name);
            surveyModel.getQuestionByName(mappedFields.FullName.question).readOnly = true;
          }
          if (mappedFields.PreferredName.question !== '') {
            surveyModel.setValue(mappedFields.PreferredName.question, objectToProcess.preferred_name);
            surveyModel.getQuestionByName(mappedFields.PreferredName.question).readOnly = true;
          }
          if (mappedFields.emailaddress.question !== '') {
            surveyModel.setValue(mappedFields.emailaddress.question, objectToProcess.email);
          }
          if (mappedFields.Phone.question !== '') {
            surveyModel.setValue(mappedFields.Phone.question, objectToProcess.mobile);
          }
        }
        break;
      case 'person_relationships':
        if (objectToProcess) {
          const relationships = objectToProcess.filter(function (relationship: any) {
            return relationship.role_type === 'MLO' || relationship.role_type === 'R';
          });
          if (relationships.length > 0) {
            if (mappedFields.LicenseNumber.question !== '') {
              surveyModel.setValue(mappedFields.LicenseNumber.question, relationships[0].license_number);
              if (!surveyModel.getVariable('allow_edit_mappedFields_license')) { // set by assoc in custom.js
                surveyModel.getQuestionByName(mappedFields.LicenseNumber.question).readOnly = true;
              }
            }
            if (mappedFields.Role.question !== '') {
              surveyModel.setValue(mappedFields.Role.question, relationships[0].role_description);
              surveyModel.getQuestionByName(mappedFields.Role.question).readOnly = true;
            }
            if (mappedFields.Office.question !== '') {
              surveyModel.setValue(mappedFields.Office.question, relationships[0].office_name);
              surveyModel.getQuestionByName(mappedFields.Office.question).readOnly = true;
            }
            surveyModel.setVariable('current_office_name', relationships[0].office_name); // used on DR Transfer
          }
        }
        break;
      case 'office':
        if (objectToProcess) {
          if (mappedFields.Office.question !== '') {
            surveyModel.setValue(mappedFields.Office.question, objectToProcess.business_name);
            surveyModel.getQuestionByName(mappedFields.Office.question).readOnly = true;
          }
          if (mappedFields.officeNRDS.question !== '') {
            surveyModel.setValue(mappedFields.officeNRDS.question, objectToProcess.office_nrds_id);
            surveyModel.getQuestionByName(mappedFields.officeNRDS.question).readOnly = true;
          }
          if (mappedFields.officeMLSID.question !== '') {
            surveyModel.setValue(mappedFields.officeMLSID.question, objectToProcess.field_description.office_mls_id);
            surveyModel.getQuestionByName(mappedFields.officeMLSID.question).readOnly = true;
          }
          if (mappedFields.office_street_1.question !== '') {
            surveyModel.setValue(mappedFields.office_street_1.question, objectToProcess.physical_street1);
          }
          if (mappedFields.office_street_2.question !== '') {
            surveyModel.setValue(mappedFields.office_street_2.question, objectToProcess.physical_street2);
          }
          if (mappedFields.office_city.question !== '') {
            surveyModel.setValue(mappedFields.office_city.question, objectToProcess.physical_city);
          }
          if (mappedFields.office_state.question !== '') {
            surveyModel.setValue(mappedFields.office_state.question, objectToProcess.physical_state);
          }
          if (mappedFields.office_zip.question !== '') {
            surveyModel.setValue(mappedFields.office_zip.question, objectToProcess.physical_zip);
          }
          if (mappedFields.office_full_address.question !== '') {
            if (objectToProcess.physical_street2 === '') {
              var full_office_address = objectToProcess.physical_street1 + ' ' + objectToProcess.physical_city + ', ' + objectToProcess.physical_state + ' ' + objectToProcess.physical_zip;
            } else {
              var full_office_address = objectToProcess.physical_street1 + ' ' + objectToProcess.physical_street2 + ' ' + objectToProcess.physical_city + ', ' + objectToProcess.physical_state + ' ' + objectToProcess.physical_zip;
            }
            surveyModel.setValue(mappedFields.office_full_address.question, full_office_address);
          }
        }
        break;
      case 'member':
        if (objectToProcess) {
          if (mappedFields.home_street_1.question !== '') {
            surveyModel.setValue(mappedFields.home_street_1.question, objectToProcess.home_street1);
            if (surveyModel.getQuestionByName('CivicInformation') !== null) {
              if (!surveyModel.getQuestionByName('CivicInformation')) return;

              const that = this;
              setTimeout(() => {
                const address = this.buildAddressString(surveyModel, mappedFields);
                that.civicDataUtilsService.getCivicData(address, surveyModel);
              }, 1000);
            }
          }
          if (mappedFields.memberNRDS.question !== '') {
            surveyModel.setValue(mappedFields.memberNRDS.question, objectToProcess.member_nrds_id);
          }
          if (mappedFields.home_street_2.question !== '') {
            surveyModel.setValue(mappedFields.home_street_2.question, objectToProcess.home_street2);
          }
          if (mappedFields.home_city.question !== '') {
            surveyModel.setValue(mappedFields.home_city.question, objectToProcess.home_city);
          }
          if (mappedFields.home_state.question !== '') {
            surveyModel.setValue(mappedFields.home_state.question, objectToProcess.home_state);
          }
          if (mappedFields.home_zip.question !== '') {
            surveyModel.setValue(mappedFields.home_zip.question, objectToProcess.home_zip);
          }
          if (mappedFields.home_full_address.question !== '') {
            if (objectToProcess.home_street2 === '') {
              var home_full_address = objectToProcess.home_street1 + ' ' + objectToProcess.home_city + ', ' + objectToProcess.home_state + ' ' + objectToProcess.home_zip;
            } else {
              var home_full_address = objectToProcess.home_street1 + ' ' + objectToProcess.home_street2 + ' ' + objectToProcess.home_city + ', ' + objectToProcess.home_state + ' ' + objectToProcess.home_zip;
            }
            surveyModel.setValue(mappedFields.home_full_address.question, home_full_address);
          }
        }
        break;
      case 'association':
        if (objectToProcess) {
          if (mappedFields.LocalAssociation.question !== '') {
            surveyModel.setValue(mappedFields.LocalAssociation.question, objectToProcess.association_nrds_id);
            surveyModel.getQuestionByName(mappedFields.LocalAssociation.question).readOnly = true;
          }
          if (mappedFields.LocalAssociationName.question !== '') {
            surveyModel.setValue(mappedFields.LocalAssociationName.question, objectToProcess.business_name);
            surveyModel.getQuestionByName(mappedFields.LocalAssociationName.question).readOnly = true;
          }
        }
        break;
    }
  }

  getMappedFields(model: Model) {
    const mappedFields: any = {
      'FirstName': {'question': '', 'source': 'person_profile'},
      'LastName': {'question': '', 'source': 'person_profile'},
      'FullName': {'question': '', 'source': 'person_profile'},
      'PreferredName': {'question': '', 'source': 'person_profile'},
      'emailaddress': {'question': '', 'source': 'person_profile'},
      'Phone': {'question': '', 'source': 'person_profile'},
      'Office': {'question': '', 'source': 'office_profile'},
      'officeNRDS': {'question': '', 'source': 'office_profile'},
      'officeMLSID': {'question': '', 'source': 'office_profile'},
      'office_street_1': {'question': '', 'source': 'office_profile'},
      'office_street_2': {'question': '', 'source': 'office_profile'},
      'office_city': {'question': '', 'source': 'office_profile'},
      'office_state': {'question': '', 'source': 'office_profile'},
      'office_zip': {'question': '', 'source': 'office_profile'},
      'office_full_address': {'question': '', 'source': 'office_profile'},
      'Role': {'question': '', 'source': 'person_relationships'},
      'LicenseNumber': {'question': '', 'source': 'person_relationships'},
      'LocalAssociation': {'question': '', 'source': 'assoc_profile'},
      'LocalAssociationName': {'question': '', 'source': 'assoc_profile'},
      'memberNRDS': {'question': '', 'source': 'member_profile'},
      'home_street_1': {'question': '', 'source': 'member_profile'},
      'home_street_2': {'question': '', 'source': 'member_profile'},
      'home_city': {'question': '', 'source': 'member_profile'},
      'home_state': {'question': '', 'source': 'member_profile'},
      'home_zip': {'question': '', 'source': 'member_profile'},
      'home_full_address': {'question': '', 'source': 'member_profile'},
      'CommitteeApplications': {'question': '', 'source': 'committee_terms'},
      'OfficeRoster': {'question': '', 'source': 'office_roster'},
    };

    let allQuestions = model.getAllQuestions();
    for (const question of allQuestions) {
      Object.keys(mappedFields).forEach(function (field) {
        if (question['jsonObj']['mappedField'] === field) {
          mappedFields[field].question = question['jsonObj']['name'];
        }
      });
    }
    return mappedFields;
  }

  private buildAddressString(survey: Model, mapped: any): string {
    return `${survey.getValue(mapped.home_street_1.question)} ${survey.getValue(mapped.home_city.question)} ${survey.getValue(mapped.home_state.question)} ${survey.getValue(mapped.home_zip.question)}`;
  }
}
